DialogEditCategoriaCtrl.$inject = ['$log', '$scope', '$http'];
export default function DialogEditCategoriaCtrl($log, $scope, $http) {
    var vm = this;

    vm.model = $scope.model;
    vm.dialogHandler = $scope.dialog;
    vm.cargando = {
        datos: false,
        submit: false
    };
    vm.categoriaId = vm.model.categoriaId;
    vm.modoEdicion = typeof vm.categoriaId != 'undefined';
    vm.formDeshabilitado = false;

    function crearCategoria(categoria) {
        vm.cargando.submit = true;
        vm.formDeshabilitado = true;

        var url = Sigo.var.path + '/api/v1/categorias';

        var promise = $http.post(url, categoria);
        promise.then(function (data) {
            Sigo.UI.Toast.success('', 'Categoría añadida!');
            vm.dialogHandler.close(data);
        });
        return promise;
    }

    vm.submit = function (categoria, modoEdicion) {
        // return (modoEdicion) ? crearCategoria(categoria) : editarCategoria(categoria.id, categoria);
        return crearCategoria(categoria);
    };

    vm.cancelar = function () {
        vm.dialogHandler.cancel();
    }
}